/**
 * Page-body controller blocks with an empty template whose only job is to open
 * a modal. CMS often marks them `neverVisible` so they take no layout space;
 * they must still be instantiated or the modal never opens.
 *
 * A real visibility condition that evaluates to false (test mode, shop, …)
 * must NOT keep the launcher alive: otherwise the hidden block still opens
 * its modal.
 */
const BLOCK_TYPES_INSTANTIATED_WHEN_HIDDEN = new Set([
  'KioskSuggestionsModalBlockComponent',
  'KioskCartRecommendationCardsBlockComponent',
]);

export function shouldInstantiateBlockWhenHidden(
  blockType: string,
  conditionalVisibility?: { conditions?: { type?: string }[] } | null,
): boolean {
  if (!BLOCK_TYPES_INSTANTIATED_WHEN_HIDDEN.has(blockType)) {
    return false;
  }
  return (conditionalVisibility?.conditions ?? []).some(
    condition => condition?.type === 'neverVisible',
  );
}
